
import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
import SweetAlertService from "./SweetAlertService";
const FinalPaymentService = {
    async getFinalPayment(staffID, date) {
        let obj = {
            staffID: staffID,
            date: date
        }

        const response = await httpClient.post(endPoints.getFinalPayment, obj);
        return response
    },
    async saveFinalPayment(model) {
        let obj = {
            model: model
        }

        const response = await httpClient.post(endPoints.saveFinalPayment, obj);
        return response
    },
    async delFinalPayment(txNum) {
        let obj = {
            txNum: txNum
        }

        const response = await httpClient.post(endPoints.delFinalPayment, obj);
        return response
    },
    async submitFinalPayment(txNum, status, staffID) {
        let obj = {
            txNum: txNum,
            status: status,
            staffID: staffID
        }

        const response = await httpClient.post(endPoints.submitFinalPayment, obj);
        return response;
    },
    async printFinalPayment(txNum, status, staffID) {
        let obj = {
            txNum: txNum,
            status: status,
            staffID: staffID
        }

        const response = await httpClient.post(endPoints.printFinalPayment, obj);
        return response;
    },

    async ApproveOrReject(txNum, status, staffID) {
        let obj = {
            txNum: txNum,
            status: status,
            staffID: staffID
        }

        const response = await httpClient.post(endPoints.approveFinalPayment, obj);
        return response;
    }
}

export default FinalPaymentService;


// WEBPACK FOOTER //
// ./src/service/FinalPaymentService.js